

exports.__esModule = true;
exports.$xoShippingComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _sharedUtil = require('../services/shared-util');

require('xo-member-components/src/select-shipping/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
    tag: 'xo-shipping',
    template: _template2['default'],

    scope: {
        backUri: '=?',
        shippingChangeFeature: '=?'
    },

    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'select_shipping_rendered',
            to: 'prepare_select_shipping'
        });
        $scope.onComplete = function (result) {
            _uiRouter.$state.go($scope.backUri || 'checkout.review');
        };
    }]
});

angular.value("$xoShippingComponent", $xoShippingComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;

_sharedUtil.$SharedUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shipping/directive.js
// module id = ./pages/xo-shipping/directive.js
// module chunks = 0